module.exports = __webpack_public_path__ + "static/media/grand_mum_talking_perfect.ef45ff19.gif";